// extracted by mini-css-extract-plugin
export default {"card":"CardForData_card__-889V","cardTitle":"CardForData_cardTitle__UEVxI","valueContainer":"CardForData_valueContainer__BbBp7","value":"CardForData_value__AQ9xf"};